import { Avatar, Typography, ListItem, ListItemAvatar, 
  ListItemText } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities';
import * as Utils from '../util/Utils'

const handleStyle = {
  // display: 'flex',
  // width: '12px',
  // padding: '15px',
  // alignItems: 'center',
  // justifyContent: 'center',
  // flex: '0 0 auto',
  // touch - action: none,
  cursor: 'var(--cursor, pointer)',
  // border - radius: 5px,
  border: 'none',
  outline: 'none',
  // appearance: none,
  backgroundColor: 'transparent',
  // -webkit - tap - highlight - color: transparent,
}


export default function DragableScan(props: {
  scan: any,
  index: number,
  selectedIndex: number[],
  toggleSelection: (e: any, index: number) => void,
  selectIndex: (index: number) => void
}) {

  const {attributes, listeners, setNodeRef, 
    transform, transition} = useSortable({
      id: props.scan['id'],
    });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform)
  };

  return (
    <ListItem
      tabIndex={0}
      ref={setNodeRef}
      key={props.scan.id}
      id={props.scan.id}
      style={style}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          props.selectIndex(props.index);
        }
      }}
      onClick={e => props.selectIndex(props.index)}
      className={`${props.selectedIndex.indexOf(props.index) >= 0 ? 'selected' : ''}`}
      sx={{
        padding: '10px',
        borderBottom: '1px solid #eeeeee',        
      }}
      secondaryAction={
        <button aria-label={`Drag Handle ${props.index}`} style={handleStyle} 
          {...attributes} {...listeners} ref={setNodeRef}>
          <DragIndicatorIcon fontSize='small' color='inherit'
            sx={{"&:hover": {cursor: 'grab'}}}
          />
        </button>
      }
    >
      <ListItemAvatar>
        <Avatar
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              props.toggleSelection(event, props.index);
            }
          }}
          onClick={e => props.toggleSelection(e, props.index)}
          className={`item-selector ${props.selectedIndex.indexOf(props.index) >= 0 ? 'selected' : ''}`}
          sx={{
            fontSize: '80%',
            marginRight: '50px',
            width: 40, height: 40,
          }}
        >
          {props.index + 1}
        </Avatar>
      </ListItemAvatar>

      {
        props.scan['message']
          ?
          <ListItemText primary={props.scan['name']}
            secondary={
              <Typography color={'#c62828'}>
                {props.scan['message']}
              </Typography>
            }
          />
          :
          <ListItemText 
            primary={
              <div style={{display: 'flex'}}>
                <Typography variant="body1" 
                color={Utils.validateTarget(props.scan)['isNameValid'] ? '' : '#c62828'}>
                  {props.scan['name']}
                </Typography>
                <Typography sx={{marginLeft: '5px'}}
                  variant="caption">
                  {(props.scan || {})['isCalibrator'] ? 'C' : 'T'}
                </Typography>
              </div>
            }
            secondary={
              <Typography variant="body2"
                color={(Utils.validateTarget(props.scan)['isRAValid'] && Utils.validateTarget(props.scan)['isDecValid']) ? '' : '#c62828'}
              >
                {props.scan['ra']} {props.scan['dec']} {props.scan['coord_sys']||'J2000'}
                {' '} {Utils.getTargetVelocityString(props.scan)}
              </Typography>
            }
          />
      }
    </ListItem>
  );
}

